export const topicFilterInputWidth = {
    base: '287px',
    tablet: '332px'
};
